import { render, staticRenderFns } from "./RootItem.vue?vue&type=template&id=0b5f142c&scoped=true&"
import script from "./RootItem.vue?vue&type=script&lang=js&"
export * from "./RootItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5f142c",
  null
  
)

export default component.exports